import { createContext, useContext, useSyncExternalStore } from 'react';
import type { ApiClient, SessionSnapshot, TokenManager } from '@adiox/api';

export interface SessionContextValue {
  tokens: TokenManager;
  api: ApiClient;
}

export const SessionContext = createContext<SessionContextValue | null>(null);

export function useSessionContext(): SessionContextValue {
  const value = useContext(SessionContext);
  if (!value) {
    throw new Error('SessionProvider is missing');
  }
  return value;
}

export function useSession(): SessionSnapshot {
  const { tokens } = useSessionContext();
  return useSyncExternalStore(
    (onChange) => tokens.subscribe(onChange),
    () => tokens.session,
  );
}

export function useApi(): ApiClient {
  return useSessionContext().api;
}
